import {withHandlers} from 'recompose'

import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import {withQueryParam} from '../../../../hooks/routes'
import type {State} from '../../../../reducers/types'
import {getHrefWithQueryParams, withLocation} from '../../../../routes'
import {getBuild, getBuildType} from '../../../../selectors'
import type {BuildTypeId, ProjectId, BuildId} from '../../../../types'
import {getShowChangedOnly} from '../CompareBuildsPage.selectors'

import CompareBuildsTable from './CompareBuildsTable'

type OwnProps = {
  type: string
  sourceId: BuildId
  compareWithId: BuildId | null | undefined
  wide: boolean
}
type StateProps = {
  buildTypeId: BuildTypeId | null | undefined
  showChangedOnly: boolean
  sourceProjectId: ProjectId | null | undefined
  compareProjectId: ProjectId | null | undefined
  sourceBuildNumber: string | null | undefined
  compareBuildNumber: string | null | undefined
}

const mapStateToProps = (state: State, {sourceId, compareWithId}: OwnProps): StateProps => {
  const sourceBuild = getBuild(state, sourceId)
  const compareBuild = getBuild(state, compareWithId)
  return {
    buildTypeId: sourceBuild?.buildType,
    showChangedOnly: getShowChangedOnly(state),
    sourceProjectId: getBuildType(state, sourceBuild?.buildType)?.projectId,
    compareProjectId: getBuildType(state, compareBuild?.buildType)?.projectId,
    sourceBuildNumber: sourceBuild?.number,
    compareBuildNumber: compareBuild?.number,
  }
}

export default compose(
  connect(mapStateToProps),
  withLocation,
  withQueryParam('filterText'),
  withHandlers({
    changeFilterText:
      ({location, navigate}) =>
      (filterText: string) =>
        navigate(
          getHrefWithQueryParams(location, null, params => ({
            ...params,
            filterText: !filterText ? null : filterText,
          })),
        ),
  }),
)(CompareBuildsTable)
